// Stable client interface: feature modules own endpoint calls while existing
// consumers retain their imports, method receivers and ApiError identity.
import { apiAssetUrl } from "./api-client/transport";
import { analyticsApi } from "./api-client/analytics";
import { profilesApi } from "./api-client/profiles";
import { accountApi } from "./api-client/account";
import { catalogApi } from "./api-client/catalog";
import { administrationApi } from "./api-client/administration";
import { contentApi } from "./api-client/content";
import { moderationApi } from "./api-client/moderation";
import { legalApi } from "./api-client/legal";
import { privacyApi } from "./api-client/privacy";
import { supportApi } from "./api-client/support";
import { notificationsApi } from "./api-client/notifications";
import { projectsApi } from "./api-client/projects";
import { quotationsApi } from "./api-client/quotations";
import { contractsApi } from "./api-client/contracts";
import { messagingApi } from "./api-client/messaging";
import { paymentsApi } from "./api-client/payments";
import { companiesApi } from "./api-client/companies";
import { itemsApi } from "./api-client/items";
import { employmentApi } from "./api-client/employment";
import { employmentAgreementsApi } from "./api-client/employmentAgreements";
import { disputesApi } from "./api-client/disputes";
import { changelogApi } from "./api-client/changelog";
import { workReportsApi } from "./api-client/workReports";
import { workHistoryApi } from "./api-client/workHistory";
import { workExportApi } from "./api-client/workExport";
import { contractActivityApi } from "./api-client/contractActivity";

export type * from "./api-client/types";
export type * from "./api-client/changelog";
export { MAX_MESSAGE_LENGTH, MAX_DISPUTE_IMAGE_BYTES, apiAssetUrl, getToken, ApiError } from "./api-client/transport";
export { ACTIVITY_LABELS } from "./api-client/account";

export const api = {
  apiAssetUrl,
  ...analyticsApi,
  ...profilesApi,
  ...accountApi,
  ...catalogApi,
  ...administrationApi,
  ...contentApi,
  ...moderationApi,
  ...legalApi,
  ...privacyApi,
  ...supportApi,
  ...notificationsApi,
  ...projectsApi,
  ...quotationsApi,
  ...contractsApi,
  ...messagingApi,
  ...paymentsApi,
  ...companiesApi,
  ...itemsApi,
  ...employmentApi,
  ...employmentAgreementsApi,
  ...disputesApi,
  ...changelogApi,
  ...workReportsApi,
  ...workHistoryApi,
  ...workExportApi,
  ...contractActivityApi,
};
